import React from 'react'
import commonStyles from '../../AddPayerCommonStyles.styles';
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import CardWIconTitleAndButton from '../../../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton';
import styles from "./GetPayerType.styles"
import { PAYER_TYPE, PAYER_TYPE_1042_S } from './constants';

export default function GetPayerType({
    onCardClickCb = () => { },
    type = "",
    payerLabel = "Payer",
    heading = `How would you describe this ${payerLabel}?`,
    description = `A ${payerLabel} is someone who makes payments to other recipients.`,
    is1042SForm = false,
}) {

    const cards = is1042SForm ? PAYER_TYPE_1042_S : PAYER_TYPE;

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>{heading}</Heading>
                    <p>{description}</p>
                </div>

                <div style={commonStyles.cardsGroupContainer}>

                    {
                        cards.map((card, idx) => (

                            <div style={commonStyles.cardContainer} onClick={() => onCardClickCb(card)}>
                                <CardWIconTitleAndButton
                                    title={card.title}
                                    icon={card.icon}
                                    customStyles={styles.individualCardStyle}
                                    isHighlighted={type === card.title ? true : false}
                                    justifyContent="center"
                                    headerCustomStyles={styles.cardHeader}
                                />
                            </div>

                        ))
                    }

                </div>
            </div>
        </>
    )
}